import a_clockwork_orange from './img/a_clockwork_orange.jpg'
import a_wrinkle_in_time from './img/a_wrinkle_in_time.jpg'
import binti from './img/binti.jpg'
import children_of_time from './img/children_of_time.jpg'
import contact from './img/contact.jpg'
import doomsday_book from './img/doomsday_book.jpg'
import enders_game from './img/enders_game.jpg'
import exhalation from './img/exhalation.jpg'
import hyperion from './img/hyperion.jpg'
import jurassic_park from './img/jurassic_park.png'
import neuromancer from './img/neuromancer.jpg'
import oldman_war from './img/oldman_war.jpg'
import oryx_crake from './img/oryx_crake.jpg'
import sea_of_tranquility from './img/sea_of_tranquility.jpg'
import snow_crash from './img/snow_crash.jpg'
import space2001 from './img/space2001.jpg'
import station_eleven from './img/station_eleven.jpg'
import stranger_in_A_strange_land from './img/stranger_in_A_strange_land.jpg'
import the_dispossessed from './img/the_dispossessed.jpg'
import the_left_hand_of_Darkness from './img/the_left_hand_of_Darkness.jpg'
import the_martian from './img/the_martian.jpg'
import the_moon_is_A_harsh_mistress from './img/the_moon_is_A_harsh_mistress.jpg'
import the_three_body_problem from './img/the_three_body_problem.jpg'
import the_time_machine from './img/the_time_machine.jpg'


export const SCBookItems = [
  {
    id:901,
    title:"A Clockwork Orange",
    image: a_clockwork_orange,
    price:1499,
    
  },
  {
    id:902,
    title:"A Wrinkle in Time",
    image: a_wrinkle_in_time,
    price:1199,
    
  },
  {
    id:903,
    title:"Binti",
    image: binti,
    price:679,
    
  },
  {
    id:904,
    title:"Children Of Time",
    image: children_of_time,
    price:629,
    
  },
  {
    id:905,
    title:"Contact",
    image: contact,
    price:1599,
    
  },
  {
    id:906,
    title:"Doomsday Book",
    image: doomsday_book,
    price:639,
    
  },
  {
    id:907,
    title:"Ender's Game",
    image: enders_game,
    price:3179,
    
  },
  {
    id:908,
    title:"Exhalation",
    image: exhalation,
    price:2999,
    
  },
  {
    id:909,
    title:"Hyperion",
    image: hyperion,
    price:729,
    
  },
  {
    id:910,
    title:"Jurassic Park",
    image: jurassic_park,
    price:699,
    
  },
  {
    id:911,
    title:"Neuromancer",
    image:neuromancer,
    price:399,
    
  },
  {
    id:912,
    title:"Old Man's War",
    image: oldman_war,
    price:999,
    
  },
  {
    id:913,
    price:799,
    title: "Oryx & Crake",
    image: oryx_crake,
    
  },
  {
    id:914,
    price:1699,
    title: "Sea of Tranquility",
    image: sea_of_tranquility,
   
  },
  {id:915,
    price:399,
    title: "Snow Crash",
    image:  snow_crash,
    
  },
  {
    id:916,
    price:749,
    title: "2021 A Space",
    image: space2001,
    
  },
  {
    id:917,
    price:1349,
    title: "Station Eleven",
    image: station_eleven,
    
  },
  {
    id:918,
    price:4019,
    title: "Stranger in a Strange Land",
    image: stranger_in_A_strange_land,
    
  },
  {
    id:919,
    price:669,
    title: "The Dispossessed",
    image: the_dispossessed,
    
  },
  {
    id:920,
    price:599,
    title: "The Left Hand of Darkness",
    image: the_left_hand_of_Darkness,
    
  },
  {
    id:921,
    price:1999,
    title: "The Martian",
    image: the_martian ,
    
  },
  {
    id:922,
    price:999,
    title: "The Moon is a Harsh Mistress",
    image: the_moon_is_A_harsh_mistress,
    
  },
  {
    id:923,
    price:1099,
    title: "The Three-Body Problem",
    image: the_three_body_problem,
    
  },
  {
    id:924,
    price:199,
    title: "The Time Machine",
    image: the_time_machine,
    
  },
  
];